import { useState, useEffect, CSSProperties } from 'react';
import { Typography, Dialog } from './../../../tailwindcomponents';
import { EmployeeSearch } from './../../../components';
import toolsApi from './../../../api/tools';
import RingLoader from "react-spinners/RingLoader";

const override: CSSProperties = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
};

interface UserCardsProps {
    setLoading: (loading: boolean) => void;
}

function UserCards({ setLoading }: UserCardsProps) {
    const [userCardDialopgOpen, setUserCardDialogOpen] = useState(false);
    const [givenUserCardCode, setGivenUserCardCode] = useState("");
    const [employeeSearch, setemployeeSearch] = useState<number>(-1);

    useEffect(() => {
        const escFunction = (event: any) => {
            if (event.keyCode === 13) { document.getElementById("press-Enter")?.click() }
        }
        document.addEventListener('keydown', escFunction, false);
    }, [])

    const onConfirmEmployee = (employeeId: number) => {
        if (employeeId !== 0) {
            setemployeeSearch(employeeId);
            setUserCardDialogOpen(true);
            setInterval(function () {
                const returnInput = document.getElementById('user_id_number');
                returnInput?.focus();
            }, 1000);
        }
    }
    const onUSerCardCodeChange = (code: string) => {
        setGivenUserCardCode(code);
    }
    const handleEnterPressed = () => {
        const userCardCode = givenUserCardCode.trim();
        setUserCardDialogOpen(false);
        setLoading(true);
        toolsApi.UpdateUserCardCodes(employeeSearch, userCardCode).then(res => {
            setGivenUserCardCode("");
        }).finally(() => setLoading(false));
    }
    return (
        <div className="w-full">
            <Typography text={"Employee User Cards"} align="center" variant="h2" />
            <div className="flex flex-wrap w-full lg:w-1/2 justify-center m-auto">
                <EmployeeSearch
                    inputWidth={90}
                    place_holder={"Write employee name"}
                    onSelectedEmployee={(employeeId: number) => onConfirmEmployee(employeeId)}
                />
            </div>
            <button id="press-Enter" onClick={() => handleEnterPressed()} className="sr-only"></button>
            <Dialog
                visible={userCardDialopgOpen}
                max_width={"sm"} title={"Please make sure employee scans his cards"}
                context={
                    <div>
                        <RingLoader color={"#36D7B7"} loading={true} cssOverride={override} />
                        <input id="user_id_number" placeholder={"Write user card code"} value={givenUserCardCode} onChange={(e) => { onUSerCardCodeChange(e.target.value) }} ></input>
                    </div>
                }
                onClose={(status: any) => setUserCardDialogOpen(false)}
                strict={false}
                show_options={false}
            />
        </div>
    );
};
export default UserCards;